import {
  ICreateIssueMetaResponse,
  JiraIssueRequestType
} from "../../../types/jira-api";
import { baseAPI } from "../../api";

const jiraApi = baseAPI.injectEndpoints({
  endpoints: (builder) => ({
    getCreateJiraIssueMeta: builder.query<ICreateIssueMetaResponse, void>({
      query: () => {
        const internalApi = window.location.origin;
        return {
          url: `${internalApi}/api/jira/create-issue-meta`
        };
      }
    }),
    createJiraIssue: builder.mutation<void, JiraIssueRequestType>({
      query: (DTO) => {
        const internalApi = window.location.origin;
        return {
          url: `${internalApi}/api/jira/create-issue`,
          method: "POST",
          body: DTO
        };
      }
    })
  })
});

export const { useCreateJiraIssueMutation, useGetCreateJiraIssueMetaQuery } =
  jiraApi;
